export const images = [
  {
    src: "./images/imga2.jpg",
    original: "./images/imga2.jpg",
    // tags: [{ value: "People", title: "People" }],
    // caption: "Old Barn (Tom Eversley - isorepublic.com)",
  },
  {
    src: "./images/imga1.jpg",
    original: "./images/imga1.jpg",
    // caption: "Old Barn (Tom Eversley - isorepublic.com)",
  },
  {
    src: "./images/img3.jpg",
    original: "./images/img3.jpg",
  },

  {
    src: "./images/road01.png",
    original: "./images/road02.png",
  },
  {
    src: "./images/road02.png",
    original: "./images/road02.png",
  },
  {
    src: "./images/road03.png",
    original: "./images/road03.png",
  },
  {
    src: "./images/road04.png",
    original: "./images/road04.png",
  },
  {
    src: "./images/road05.png",
    original: "./images/road05.png",
  },
];
